import validator from 'validator'
import moment from 'moment'

export function customValidation(value, validate) {
    if (validate === 'postal' && !validator.isPostalCode(value, 'CA')) return false
    if (validate === 'positiveNumber' && (validator.isEmpty(value) || !validator.isInt(value) || parseInt(value) <= 0)) return false
    if (validate === 'dateFormatYMD' && !moment(value, "YYYY-MM-DD", true).isValid()) return false
    return true
}